(() => {
 const cache=new Map();
 // Preserve the entire source, including white margins, in previews and production exports.
 const prepare=src=>{
  const key=new URL(src,location.href).href;
  if(cache.has(key))return cache.get(key);
  const work=(async()=>{
   const image=new Image();image.crossOrigin='anonymous';image.src=key;await image.decode();
   const width=image.naturalWidth,height=image.naturalHeight,canvas=document.createElement('canvas');canvas.width=width;canvas.height=height;
   canvas.getContext('2d').drawImage(image,0,0);
   return {src:key,canvas,crop:{x:0,y:0,width,height}};
  })();cache.set(key,work);work.catch(()=>cache.delete(key));return work;
 };
 window.BBFramedArt={prepare};
})();
